import { transactionClientHttpClient } from "../../../installations/axiosInterfaces";

const addTransactionClient = (companyId, data) => {
  return transactionClientHttpClient.post(`Add/${companyId}`, data);
};

const getIdAndValidateByPhoneNumber = (companyId, phoneNumber) => {
  return transactionClientHttpClient.get(`GetIdAndValidateByPhoneNumber/${companyId}/${phoneNumber}`);
};

const resendClientAccessCode = (companyId, clientId) => {
  return transactionClientHttpClient.get(`AccessCode/resend/${companyId}/${clientId}`);
};

const validateTransactionClientAccessCode = (clientId, accessCode) => {
  return transactionClientHttpClient.get(`AccessCode/Validate/${clientId}/${accessCode}`);
};

const transactionClientService = {
  addTransactionClient,
  getIdAndValidateByPhoneNumber,
  resendClientAccessCode,
  validateTransactionClientAccessCode,
};

export default transactionClientService;
